export default __webpack_public_path__ + "static/media/zigzag.5503f256.png";